

















































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { JsonServiceClient, toFormData } from '@servicestack/client';
import { redirect, Routes } from '../shared/router';
import { bus, store, client, getUserInfo } from '../shared';
import { UserInfo } from '../shared/user';
import _ from 'lodash';
@Component({
    components: {},
})
export default class Submission extends Vue {
    activeSession: any = {};
    title = 'Data Study Submission';
    subtitle = 'Your Data Study submission details are as follows.';
    iidpIsletStudyDashboard: any = '';
    iidpDataStudyDashboard: any = '';
    form: any = {
        userId: '',
        rowId: 0,
        firstName: '',
        lastName: '',
        degree: '',
        title: '',
        dataProjectId: '',
        hasORCID: false,
        rsnNoORCID: '',
        orcid: '',
        institution: '',
        email: '',
        phone: '',
        addressline1: '',
        addressline2: '',
        city: '',
        state: '',
        country: '',
        stateOther: '',
        province: '',
        zip: '',
        projectTitle: '',
        projectSummary: '',
        fundingAvailable: false,
        supportType: '',
        supportTypeOther: '',
        grantNumber: '',
        projectEndMonth: '',
        projectEndYear: '',
        cellStimulus: false,
        cellDeath: false,
        type1Diabetes: false,
        tissueEngineering: false,
        alphaCells: false,
        geneticsGenomics: false,
        otherArea: false,
        otherAreaText: '',
        phoneExt: '',
        finalSubmissionDate: '',
        personId: '',
        role: '',
        submit: false,
    };
    /* ------------- Data -------------------- */
    /* ------------- Props ------------------- */
    get userInfo() {
        return store.userInfo;
    }
    get userSession() {
        return store.userSession;
    }
    /* ------------- Computed ---------------- */
    /* ------------- Methods ----------------- */
    /* ------------- Lifecycle Hooks --------- */
    async created() {
        if (Object.keys(this.userInfo).length === 0) {
            const u = this.userSession!.userName;
            if (u !== undefined && u !== null) {
                const d = await client.get(new UserInfo({ userName: u }));
                bus.$set(store, 'userInfo', d);
                bus.$emit('userInfo', d);
                if (
                    this.userInfo.data !== undefined &&
                    this.userInfo.data.form !== undefined
                ) {
                    Object.assign(this.form, this.userInfo.data.form);
                }
            }
        }
        if (
            this.userInfo.data !== undefined &&
            this.userInfo.data.form !== undefined
        ) {
            Object.assign(this.form, this.userInfo.data.form);
        }
    }
    loadToForm() {
        bus.$on('userInfo', (payload: any) => {
            Object.assign(this.form, payload.data.form);
            this.activeSession = JSON.parse(
                localStorage.getItem(this.userInfo.userInfo.userName) || '{}',
            );
            if (!_.isEmpty(this.activeSession)) {

                this.form.personId = this.activeSession.personId;
            }
        });
    }
    mounted() {
        this.loadToForm();
        const iidpSecureUrl = IIDPconfig.SECURE_URL as string;
        this.iidpIsletStudyDashboard = `${iidpSecureUrl}/${IIDPconfig.ISLET_STUDY_DASHBOARD as string}`;
        this.iidpDataStudyDashboard = `${iidpSecureUrl}/${IIDPconfig.DATA_STUDY_DASHBOARD as string}`;
        if (localStorage.getItem('reloaded')) {
            // The page was just reloaded. Clear the value from local storage
            // so that it will reload the next time this page is visited.
            localStorage.removeItem('reloaded');
        } else {
            // Set a flag so that we know not to reload the page twice.
            localStorage.setItem('reloaded', '1');
            location.reload();
        }
    }
}
